import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormState } from 'react-hook-form';
import clsx from 'clsx';
import { useId } from '../../../helpers/useId/useId';
import { useFormLocalization } from '../useFormLocalization';
import { BodyTextSmall, HeadingText30 } from '../../Typography/Typography';
import * as styles from './FormInputLayout.module.scss';
import { Icon } from '../../Icon/Icon';
export function useFormInputLayout(props) {
    const { className, dependentFields, disabled, fieldId, hint, label, labelledBy, name, required, ...componentProps } = props;
    const id = useId(fieldId);
    return {
        className,
        componentProps: componentProps,
        dependentFields,
        disabled,
        hint,
        id,
        label,
        labelledBy,
        name,
        required,
    };
}
const Name = 'FormInputLayout';
/**
 * A wrapper which handles form field labels, accessibility hook ups, and styling.
 */
export const FormInputLayout = ({ className, disabled, fieldId, hint, label, labelledBy, name, required, renderInput, }) => {
    const { localization } = useFormLocalization();
    const hasNeitherLabelNorLabelledBy = !label && !labelledBy;
    const hasBothLabelAndLabelledBy = label && labelledBy;
    if (hasNeitherLabelNorLabelledBy || hasBothLabelAndLabelledBy) {
        throw new Error('Form inputs require either "label" or "labelledby" prop, but not both.');
    }
    const labelId = labelledBy ?? `${fieldId}--Label`;
    const hintId = `${fieldId}--Hint`;
    const inputId = `${fieldId}--Field`;
    const { errors } = useFormState({ name, disabled });
    const errorMessage = errors?.[name]?.message;
    const isInvalid = Boolean(errorMessage);
    const hintMessage = errorMessage ?? hint;
    return (_jsxs("div", { className: clsx(styles.container, className), "data-component": Name, children: [label && (_jsx("label", { id: labelId, htmlFor: inputId, children: _jsxs(HeadingText30, { as: "span", fontColor: "gray65", children: [required && (_jsx("span", { className: styles.required, "aria-hidden": true, children: "*" })), label] }) })), renderInput({
                disabled,
                hint,
                hintId,
                inputId,
                isValid: !isInvalid,
                labelId,
                required,
                name,
            }), hintMessage && (_jsxs("div", { id: hintId, className: styles.hintMessage, children: [isInvalid && (_jsxs("span", { className: styles.errorMessage, children: [_jsx(Icon, { name: "warning-enclosed-filled", size: 16, "aria-hidden": true }), _jsx(BodyTextSmall, { as: "span", children: localization.errorHeading })] })), _jsx(BodyTextSmall, { as: "span", children: hintMessage })] }))] }));
};
